export var kpiResourceAdapter = function kpiResourceAdapter(data) {
    return {
        id: data.id,
        name: data.name,
        client: {
            name: data.client.name,
            id: data.client.id,
            startWork: data.client.startWork
        },
        type: {
            name: data.type.name,
            id: data.type.id
        }
    };
};
export var kpiPropertyResourceAdapter = function kpiPropertyResourceAdapter(data) {
    return {
        id: data.id,
        name: data.name,
        value: data.value,
        kpiId: data.kpiId,
        period: data.period,
        kpiName: data.kpiName
    };
};
export var kpiResultResourceAdapter = function kpiResultResourceAdapter(data) {
    return {
        id: data.id,
        value: data.value,
        kpiId: data.kpiId,
        time: data.time,
        success: data.success,
        property: data.property
    };
};
